import { render } from "./shopMenus.vue?vue&type=template&id=1f9f1f8a"
import script from "./shopMenus.vue?vue&type=script&lang=js"
export * from "./shopMenus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__